import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useControlAssociationStore = create(
  persist<{
    selectedAssociationId?: string;
    setSelectedAssociationId: (id: string) => void;
    clearSelectedAssociation: () => void;
  }>(
    (set) => ({
      setSelectedAssociationId: (id: string) =>
        set({ selectedAssociationId: id }),
      clearSelectedAssociation: () => set({ selectedAssociationId: "" }),
    }),
    {
      name: "control-association",
    },
  ),
);
